import axios from "axios";
import base64 from "base-64";
import { toast } from 'react-toastify';

import ENV from "../env";

const UpdateUser = async (body) => {
    Promise.all([
        localStorage.getItem('userId'),
        localStorage.getItem('sToken')
    ]).then(async (res) => {
        let userId = JSON.parse(res[0]);
        let sToken = JSON.parse(res[1]);
        let header = base64.encode(`${userId}:${sToken}`);
        let security = `Basic ${header}`;

        const options = {
            headers: {
                Accept: 'application/json',
                Security: security,
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.post(`${ENV.LOCUSB_API}/UpdateUser`,body, options)

        if (response?.data?.success === "true") {
            // toast.success("Profile Updated!")
            return response
        }
        else {
            toast.error("Profile updation failed!")
            return response

        }
    }).catch((err) => {
        console.log("err", err)
    })

}

export default UpdateUser;
